import styled from 'styled-components';

export const ChartsContainer = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 15px;
  justify-content: space-between;
`;

export const ChartTitle = styled.div`
  display: flex;
  justify-content: center;

  h3 {
    color: var(--primary);
  }
`;
